import { useState } from 'react';
import { FormControl, Stack, FormLabel, Text, Box } from '@chakra-ui/react';
import { Button } from 'components/v4';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from '@/components/forms/new/formStyles';

const ConvertFromTrial = ({ darkMode, onConvert }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling(true)}
                alignItems="center">
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Convert From Trial
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        This will take the company off trial
                    </Text>
                </Box>
                <Button onClick={onConvert}>Convert</Button>
                {isHovered && (
                    <FieldToolTip
                        label="This will open up a dialog to convert this entity from trial."
                        ariaLabel="entity-trial-convert-tip"
                        left="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default ConvertFromTrial;
